import { render, staticRenderFns } from "./SAML2RequestAuth.vue?vue&type=template&id=b56bbb98&scoped=true&"
import script from "./SAML2RequestAuth.vue?vue&type=script&lang=js&"
export * from "./SAML2RequestAuth.vue?vue&type=script&lang=js&"
import style0 from "./SAML2RequestAuth.vue?vue&type=style&index=0&id=b56bbb98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56bbb98",
  null
  
)

export default component.exports